import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '~/ui/form'
import { Control, FieldPath, FieldValues } from 'react-hook-form'
import { InputHTMLAttributes } from 'react'
import { cn } from '~/lib/utils'
import { Input } from '../ui/input'

export const TextField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  name,
  label,
  showLabel = true,
  labelClassName,
  inputClassName,
  type = 'text',
  placeholder,
  disabled,
  required,
}: {
  label?: string
  showLabel?: boolean
  labelClassName?: string
  inputClassName?: string
  control: Control<TFieldValues> | undefined
  name: TName
  type?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
} & InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem>
          {showLabel && (
            <FormLabel
              className={cn(
                'mb-1 text-sm font-normal text-gray-400',
                fieldState.error && 'text-destructive',
                labelClassName
              )}
            >
              {label}
              {required && <span className="text-destructive">*</span>}
            </FormLabel>
          )}
          <FormControl>
            <Input
              {...field}
              type={type}
              placeholder={placeholder}
              disabled={disabled}
              className={inputClassName}
            />
          </FormControl>
          <FormMessage className="text-xs" />
        </FormItem>
      )}
    />
  )
}
